// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBarPagePresence-pagePresence__RAbPr{display:flex;flex-direction:row}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagePresence": "TopBarPagePresence-pagePresence__RAbPr"
};
export default ___CSS_LOADER_EXPORT___;
